import { render, staticRenderFns } from "./EventsBiddingLomList.vue?vue&type=template&id=ee252d18"
import script from "./EventsBiddingLomList.vue?vue&type=script&lang=js"
export * from "./EventsBiddingLomList.vue?vue&type=script&lang=js"
import style0 from "./EventsBiddingLomList.vue?vue&type=style&index=0&id=ee252d18&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports